import axios from "axios";
import { URL } from "../../api/tklEnvironments";
import { types } from "../../reducers/types";
import { sortBasedonSortOrder } from "./UserAction";

export const getGradeLeves = (page) => {
  return (dispatch) => {
    dispatch({ type: types.IS_LOADING, payload: true });
    let userData = JSON.parse(sessionStorage.getItem("userSortingData"));
    // !userData?.searchInput
    if (true) {
      dispatch(
        sortBasedonSortOrder(
          "grade-level",
          1,
          "gradeLevel",
          "index", //userData?.sortFieldType?.slug || "name",
          userData?.sortOrder === "Descending" ? "DESC" : "ASC" || "ASC",
          "",
          "",
          false,
          page
        )
      );
    } else {
      axios
        .get(`${URL}/grade-level?page=${page}`)
        .then(function (response) {
          if (response.data) {
            dispatch({ type: types.IS_LOADING, payload: false });
            dispatch({ type: types.IS_RELOAD, payload: false });
            dispatch({
              type: types.GET_ALL_GRADELEVELS,
              payload: response.data,
            });
          }
        })
        .catch(function (error) {
          dispatch({ type: types.IS_LOADING, payload: false });
          console.error("..error", error);
        });
    }
  };
};

export const updateGradeLevels = (payload) => {
  return (dispatch) => {
    axios
      .put(`${URL}/update-gradelevel`, payload)
      .then(function (response) {
        if (response.data) {
          dispatch({ type: types.IS_RELOAD, payload: true });
        }
      })
      .catch(function (error) {
        console.error("..error", error);
        let errorMessage = error.response?.data?.errors?.name;
        console.error("..error", errorMessage);
        if (
          errorMessage &&
          errorMessage[0] === "The name has already been taken."
        ) {
          dispatch({
            type: types.API_ERROR,
            payload: "The name has already been taken.",
          });
        }
      });
  };
};

export const addGradeLevel = (payload) => {
  return (dispatch) => {
    axios
      .post(`${URL}/add-gradelevel`, payload)
      .then(function (response) {
        if (response.data) {
          dispatch({ type: types.IS_RELOAD, payload: true });
        }
      })
      .catch(function (error) {
        console.error("..error", error);
        let errorMessage = error.response?.data?.errors?.name;
        console.error("..error", errorMessage);
        if (
          errorMessage &&
          errorMessage[0] === "The name has already been taken."
        ) {
          dispatch({
            type: types.API_ERROR,
            payload: "The name has already been taken.",
          });
        }
      });
  };
};
